import(/* webpackMode: "eager" */ "/opt/natoma/packages/frontend/src/app/(loggedin)/[tenant]/(sidebar)/loading.tsx");
